module.exports = __webpack_public_path__ + "img/vip-coupon-ratio.f843ca2f.png";